import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "nativewind/jsx-runtime";
/* eslint-disable no-restricted-imports --
   styled() 베이스. 사용자향 TabButton 은 `as={SccPressable}`, 나머지는 편집 모드 전용 도구다.
   (터치 컴포넌트는 Scc* 사용 원칙: .eslintrc.js no-restricted-imports) */
import React, { useState, useCallback, useEffect, useRef } from 'react';
import { View, Text, TouchableOpacity, ScrollView, TextInput } from 'react-native';
import styled from 'styled-components/native';
import SccPressable from '@/components/SccPressable';
import { color } from '@/constant/color';
import { useLogger } from '@/logging/useLogger';
import { LogParamsProvider } from '@/logging/LogParamsProvider';
import SccRemoteImage from '@/components/SccRemoteImage';
import IcSubway from '@/assets/icon/ic_subway.svg';
import IcTaxi from '@/assets/icon/ic_taxi.svg';
import IcCar from '@/assets/icon/ic_car.svg';
import IcBus from '@/assets/icon/ic_bus.svg';
import HtmlContentWrapper from '../components/HtmlContentWrapper';
import InteractiveImage from '../components/InteractiveImage';
import ImageUploader from '../components/ImageUploader';
import { useEditMode } from '../context/EditModeContext';
import { useResponsive } from '../context/ResponsiveContext';
const ICON_MAP = {
    SUBWAY: IcSubway,
    TAXI: IcTaxi,
    CAR: IcCar,
    BUS: IcBus,
};
const ICON_OPTIONS = ['SUBWAY', 'TAXI', 'CAR', 'BUS'];
export default function RouteSection({ routeSection, sectionId }) {
    var _a, _b, _c;
    const editContext = useEditMode();
    const isEditMode = (_a = editContext === null || editContext === void 0 ? void 0 : editContext.isEditMode) !== null && _a !== void 0 ? _a : false;
    const { isDesktop } = useResponsive();
    const logger = useLogger();
    const loggerRef = useRef(logger);
    loggerRef.current = logger;
    const [selectedRouteIndex, setSelectedRouteIndex] = useState(0);
    const selectedRoute = routeSection.routes[selectedRouteIndex];
    const handleTabPress = useCallback((index) => {
        setSelectedRouteIndex(index);
    }, []);
    // 설명 이미지 노출 로깅
    useEffect(() => {
        if (!isEditMode && (selectedRoute === null || selectedRoute === void 0 ? void 0 : selectedRoute.descriptionImageUrl)) {
            loggerRef.current.logElementView('bbucle-road-route-description-image', {
                imageUrl: selectedRoute.descriptionImageUrl,
                routeIndex: selectedRouteIndex,
                tabLabel: selectedRoute.tabLabel,
                isDesktop,
            });
        }
    }, [selectedRoute === null || selectedRoute === void 0 ? void 0 : selectedRoute.descriptionImageUrl, selectedRouteIndex, selectedRoute === null || selectedRoute === void 0 ? void 0 : selectedRoute.tabLabel, isEditMode, isDesktop]);
    // Edit mode handlers
    const updateRouteSection = useCallback((updater) => {
        if (!editContext)
            return;
        editContext.updateData((prev) => (Object.assign(Object.assign({}, prev), { routeSection: updater(prev.routeSection) })));
    }, [editContext]);
    const handleAddRoute = useCallback(() => {
        const newRoute = {
            id: `route-${Date.now()}`,
            tabLabel: '새 동선',
            tabIconType: 'SUBWAY',
            descriptionImageUrl: '',
            descriptionHtml: '',
            interactiveImage: {
                url: '',
                clickableRegions: [],
            },
        };
        updateRouteSection((prev) => (Object.assign(Object.assign({}, prev), { routes: [...prev.routes, newRoute] })));
        // 새 탭으로 이동
        setSelectedRouteIndex(routeSection.routes.length);
    }, [updateRouteSection, routeSection.routes.length]);
    const handleDeleteRoute = useCallback((index) => {
        if (routeSection.routes.length <= 1) {
            alert('최소 1개의 동선이 필요합니다.');
            return;
        }
        updateRouteSection((prev) => (Object.assign(Object.assign({}, prev), { routes: prev.routes.filter((_, i) => i !== index) })));
        // 선택된 탭 조정
        if (selectedRouteIndex >= routeSection.routes.length - 1) {
            setSelectedRouteIndex(Math.max(0, selectedRouteIndex - 1));
        }
    }, [updateRouteSection, routeSection.routes.length, selectedRouteIndex]);
    const handleUpdateRoute = useCallback((index, updates) => {
        updateRouteSection((prev) => (Object.assign(Object.assign({}, prev), { routes: prev.routes.map((route, i) => i === index ? Object.assign(Object.assign({}, route), updates) : route) })));
    }, [updateRouteSection]);
    const handleInteractiveImageChange = useCallback((url) => {
        handleUpdateRoute(selectedRouteIndex, {
            interactiveImage: Object.assign(Object.assign({}, selectedRoute.interactiveImage), { url }),
        });
    }, [handleUpdateRoute, selectedRouteIndex, selectedRoute === null || selectedRoute === void 0 ? void 0 : selectedRoute.interactiveImage]);
    // Region 변경은 이제 EditModeContext에서 처리됨
    const handleTabLabelChange = useCallback((index, label) => {
        handleUpdateRoute(index, { tabLabel: label });
    }, [handleUpdateRoute]);
    const handleIconTypeChange = useCallback((index, iconType) => {
        handleUpdateRoute(index, { tabIconType: iconType });
    }, [handleUpdateRoute]);
    return (_jsx(LogParamsProvider, { params: { displaySectionName: '교통정보', displayTabName: selectedRoute === null || selectedRoute === void 0 ? void 0 : selectedRoute.tabLabel }, children: _jsx("div", { id: sectionId, children: _jsxs(Container, { isDesktop: isDesktop, children: [_jsx(TitleSection, { children: isEditMode ? (_jsxs(_Fragment, { children: [_jsx(TitleLine1Input, { value: (_b = routeSection.titleLine1) !== null && _b !== void 0 ? _b : '', onChangeText: (text) => updateRouteSection((prev) => (Object.assign(Object.assign({}, prev), { titleLine1: text }))), placeholder: "\uD0C0\uC774\uD2C0 1\uC904 (\uAC80\uC815)", placeholderTextColor: color.gray40, isDesktop: isDesktop }), _jsx(TitleLine2Input, { value: (_c = routeSection.titleLine2) !== null && _c !== void 0 ? _c : '', onChangeText: (text) => updateRouteSection((prev) => (Object.assign(Object.assign({}, prev), { titleLine2: text }))), placeholder: "\uD0C0\uC774\uD2C0 2\uC904 (\uD30C\uB791)", placeholderTextColor: color.gray40, isDesktop: isDesktop })] })) : (_jsxs(_Fragment, { children: [_jsx(TitleLine1, { isDesktop: isDesktop, children: routeSection.titleLine1 }), _jsx(TitleLine2, { isDesktop: isDesktop, children: routeSection.titleLine2 })] })) }), _jsxs(TabsContainer, { isDesktop: isDesktop, horizontal: true, showsHorizontalScrollIndicator: false, contentContainerStyle: {
                            flexWrap: 'wrap',
                            flexGrow: 1,
                            flexShrink: 1,
                            flexBasis: '0%',
                            gap: '8px',
                        }, children: [routeSection.routes.map((route, index) => {
                                const active = index === selectedRouteIndex;
                                return (_jsxs(TabWrapper, { children: [_jsxs(TabButton, { as: SccPressable, isDesktop: isDesktop, active: active, onPress: () => handleTabPress(index), elementName: "bbucle-road-route-tab", logParams: {
                                                tabIndex: index,
                                                tabLabel: route.tabLabel,
                                                tabIconType: route.tabIconType,
                                            }, disableLogging: isEditMode, children: [(() => {
                                                    const IconComponent = ICON_MAP[route.tabIconType];
                                                    const iconSize = isDesktop ? 24 : 18;
                                                    const iconElement = _jsx(IconComponent, { width: iconSize, height: iconSize, viewBox: "0 0 16 16", color: active ? color.white : color.gray50 });
                                                    return isEditMode ? (_jsx(IconSelector, { onPress: () => {
                                                            const currentIndex = ICON_OPTIONS.indexOf(route.tabIconType);
                                                            const nextIndex = (currentIndex + 1) % ICON_OPTIONS.length;
                                                            handleIconTypeChange(index, ICON_OPTIONS[nextIndex]);
                                                        }, children: _jsx(TabIconWrapper, { isDesktop: isDesktop, active: active, children: iconElement }) })) : (_jsx(TabIconWrapper, { isDesktop: isDesktop, active: active, children: iconElement }));
                                                })(), isEditMode ? (_jsx(TabLabelInput, { value: route.tabLabel, onChangeText: (text) => handleTabLabelChange(index, text) })) : (_jsx(TabLabel, { isDesktop: isDesktop, active: active, children: route.tabLabel }))] }), isEditMode && (_jsx(TabDeleteButton, { onPress: () => handleDeleteRoute(index), children: _jsx(TabDeleteButtonText, { children: "\u00D7" }) }))] }, route.id));
                            }), isEditMode && (_jsx(AddTabButton, { onPress: handleAddRoute, children: _jsx(AddTabButtonText, { children: "+" }) }))] }), selectedRoute && (_jsxs(ContentContainer, { isDesktop: isDesktop, children: [_jsxs(DescriptionHtmlContainer, { isDesktop: isDesktop, children: [(() => {
                                        const displayHtml = (!isDesktop && selectedRoute.mobileDescriptionHtml)
                                            ? selectedRoute.mobileDescriptionHtml
                                            : selectedRoute.descriptionHtml;
                                        return displayHtml ? (_jsx(HtmlContentWrapper, { isDesktop: isDesktop, children: _jsx("div", { dangerouslySetInnerHTML: { __html: displayHtml } }) })) : null;
                                    })(), !selectedRoute.descriptionHtml && !selectedRoute.mobileDescriptionHtml && selectedRoute.descriptionImageUrl ? (_jsx(DescriptionImageWrapper, { isDesktop: isDesktop, children: _jsx(SccPressable, { onPress: () => { }, elementName: "bbucle-road-route-description-image-click", logParams: {
                                                imageUrl: selectedRoute.descriptionImageUrl,
                                                routeIndex: selectedRouteIndex,
                                                tabLabel: selectedRoute.tabLabel,
                                            }, disableLogging: isEditMode, children: _jsx(SccRemoteImage, { imageUrl: selectedRoute.descriptionImageUrl, resizeMode: "contain", style: { borderRadius: 8 } }) }) })) : null] }), _jsx(InteractiveImageContainer, { isDesktop: isDesktop, children: selectedRoute.interactiveImage.url ? (_jsx(InteractiveImage, { interactiveImage: selectedRoute.interactiveImage, onImageChange: isEditMode ? handleInteractiveImageChange : undefined, routeIndex: selectedRouteIndex })) : (isEditMode && (_jsxs(EmptyImagePlaceholder, { children: [_jsx(EmptyImageText, { children: "\uC778\uD130\uB799\uD2F0\uBE0C \uC774\uBBF8\uC9C0\uB97C \uC5C5\uB85C\uB4DC\uD558\uC138\uC694" }), _jsx(ImageUploader, { onUploadComplete: handleInteractiveImageChange, buttonText: "\uC774\uBBF8\uC9C0 \uC5C5\uB85C\uB4DC" })] }))) })] }))] }) }) }));
}
const Container = styled(View) `
  padding-vertical: ${({ isDesktop }) => (isDesktop ? '140px' : '80px')};
  padding-horizontal: 16px;
  max-width: 1020px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
`;
const TitleSection = styled(View) `
  align-items: center;
  gap: 0;
  max-width: 800px;
  width: 100%;
  padding: 0 16px;
  margin-bottom: 40px;
  align-self: center;
`;
const TitleLine1 = styled(Text) `
  font-family: Pretendard;
  font-size: ${({ isDesktop }) => (isDesktop ? '36px' : '24px')};
  font-weight: 700;
  color: ${color.black};
  text-align: center;
  line-height: ${({ isDesktop }) => (isDesktop ? '48px' : '34px')};
`;
const TitleLine2 = styled(Text) `
  font-family: Pretendard;
  font-size: ${({ isDesktop }) => (isDesktop ? '36px' : '24px')};
  font-weight: 700;
  color: #0e64d3;
  text-align: center;
  line-height: ${({ isDesktop }) => (isDesktop ? '48px' : '34px')};
`;
const TitleLine1Input = styled(TextInput) `
  font-family: Pretendard;
  font-size: ${({ isDesktop }) => (isDesktop ? '40px' : '24px')};
  font-weight: 700;
  color: ${color.black};
  text-align: center;
  width: 100%;
`;
const TitleLine2Input = styled(TextInput) `
  font-family: Pretendard;
  font-size: ${({ isDesktop }) => (isDesktop ? '40px' : '24px')};
  font-weight: 700;
  color: #0e64d3;
  text-align: center;
  width: 100%;
`;
const TabsContainer = styled(ScrollView) `
  flex-direction: row;
  margin-bottom: ${({ isDesktop }) => (isDesktop ? '40px' : '24px')};
`;
const TabWrapper = styled(View) `
  flex-direction: row;
  align-items: center;
`;
const TabButton = styled(TouchableOpacity) `
  flex-direction: row;
  align-items: center;
  padding: ${({ isDesktop }) => (isDesktop ? '10px 24px 10px 24px' : '6px 14px 6px 12px')};
  border-radius: 24px;
  background-color: ${({ active }) => (active ? color.iosBlue : color.white)};
  border: 1px ${({ active }) => (active ? color.iosBlue : color.gray50)} solid;
`;
const IconSelector = styled(TouchableOpacity) `
  margin-right: 8px;
`;
const TabIconWrapper = styled(View) `
  margin-right: ${({ isDesktop }) => (isDesktop ? '8px' : '4px')};
  color: ${({ active }) => (active ? color.white : color.gray50)};
`;
const TabLabel = styled(Text) `
  font-size: ${({ isDesktop }) => (isDesktop ? '18px' : '14px')};
  line-height: ${({ isDesktop }) => (isDesktop ? '26px' : '22px')};
  font-weight:${({ active }) => (active ? 600 : 'normal')};
  color: ${({ active }) => (active ? color.white : color.gray50)};
`;
const TabLabelInput = styled(TextInput) `
  font-size: 14px;
  font-weight: 600;
  color: ${color.white};
  padding: 0;
`;
const TabDeleteButton = styled(TouchableOpacity) `
  width: 20px;
  height: 20px;
  border-radius: 10px;
  background-color: ${color.danger};
  align-items: center;
  justify-content: center;
  margin-left: -8px;
  margin-top: -12px;
`;
const TabDeleteButtonText = styled(Text) `
  color: ${color.white};
  font-size: 14px;
  font-weight: 700;
`;
const AddTabButton = styled(TouchableOpacity) `
  width: 48px;
  height: 48px;
  border-radius: 24px;
  background-color: ${color.gray20};
  align-items: center;
  justify-content: center;
`;
const AddTabButtonText = styled(Text) `
  font-size: 24px;
  color: ${color.gray60};
`;
const ContentContainer = styled(View) `
  flex-direction: ${({ isDesktop }) => (isDesktop ? 'row' : 'column-reverse')};
  align-items: ${({ isDesktop }) => (isDesktop ? 'flex-start' : 'stretch')};
  justify-content: ${({ isDesktop }) => (isDesktop ? 'center' : 'flex-start')};
  gap: 30px;
`;
const DescriptionHtmlContainer = styled(View) `
  width: ${({ isDesktop }) => (isDesktop ? '414px' : '100%')};
  overflow: hidden;
  ${({ isDesktop }) => (isDesktop ? 'flex-shrink: 0;' : 'flex-shrink: 0;')};
`;
const DescriptionImageWrapper = styled(View) `
  position: relative;
  width: ${({ isDesktop }) => (isDesktop ? '100%' : 'calc(100% + 32px)')};
  margin-horizontal: ${({ isDesktop }) => (isDesktop ? '0' : '-16px')};
`;
const InteractiveImageContainer = styled(View) `
  ${({ isDesktop }) => (isDesktop ? '' : 'width: calc(100% + 32px)')};
  margin-horizontal: ${({ isDesktop }) => (isDesktop ? '0' : '-16px')};
  overflow: hidden;
  ${({ isDesktop }) => (isDesktop ? 'flex: 1;' : 'flex-shrink: 0;')};
`;
const EmptyImagePlaceholder = styled(View) `
  padding: 40px;
  background-color: ${color.gray5};
  border: 2px dashed ${color.gray25};
  border-radius: 8px;
  align-items: center;
  gap: 16px;
`;
const EmptyImageText = styled(Text) `
  font-size: 14px;
  color: ${color.gray60};
`;
